var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18720_8354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.57803 0 0 3.57834 0 8C0 12.422 3.57834 16 8 16C12.422 16 16 12.4217 16 8C16 3.57803 12.4216 0 8 0ZM8 14.75C4.26897 14.75 1.25 11.7308 1.25 8C1.25 4.26897 4.26922 1.25 8 1.25C11.731 1.25 14.75 4.26922 14.75 8C14.75 11.731 11.7308 14.75 8 14.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.69727C7.65481 6.69727 7.375 6.97708 7.375 7.32227V11.347C7.375 11.6922 7.65481 11.972 8 11.972C8.34519 11.972 8.625 11.6922 8.625 11.347V7.32227C8.625 6.97708 8.34519 6.69727 8 6.69727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.93164C8.46599 5.93164 8.84375 5.55388 8.84375 5.08789C8.84375 4.6219 8.46599 4.24414 8 4.24414C7.53401 4.24414 7.15625 4.6219 7.15625 5.08789C7.15625 5.55388 7.53401 5.93164 8 5.93164Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18720_8354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhiteIcon);
export default __webpack_public_path__ + "static/media/info-white-icon.e8af80919f974cc920232de0ae46e5b5.svg";
export { ForwardRef as ReactComponent };